import * as _ from 'lodash';
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import {
  IGlobalContextProps,
  withGlobalContext,
} from 'src/context/global.context';
import { deleteResume, uploadResume } from 'src/services';
import { FileInput } from '../../Files/FileInput';
import { FileItem } from '../../Files/FileItem';

const UploadResume: React.SFC<IGlobalContextProps> = ({ context }) => {
  const { user } = context;
  const resume = user && user.profile.resume;

  const handleFileUpload = async (file: any) => {
    const uploadedResumeFile = await uploadResume(file);
    if (uploadedResumeFile) {
      context.updateUser();
    }
  };

  const handleFileDelete = async (fileUuid: string) => {
    const deletedResume = await deleteResume();
    if (deletedResume) {
      context.updateUser();
    }
  };

  return (
    <Row className='pt-3'>
      {resume && resume.resumeUrl ? (
        <Col xs='4'>
          <FileItem
            edit={true}
            file={resume}
            fileUrl={resume.resumeUrl}
            handleFileDelete={handleFileDelete}
          />
        </Col>
      ) : (
        <Col xs='4'>
          <FileInput handleFileUpload={handleFileUpload} />
        </Col>
      )}
    </Row>
  );
};

export const UploadResumeWithGlobalContext = withGlobalContext(UploadResume);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateConsultantModal/UploadResume.tsx